import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useScreenSize, useCustomScreen } from "../Utils";

export default function CountsSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  return (
    <div
      className="pt-xs-5"
      style={{
        backgroundImage: "url('/images/roof-pic.png')",
        backgroundSize: "cover",
        position: "relative",
        height: isSmallScreen ? "100%" : "100vh",
      }}
    >
      <section
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          height: isSmallScreen ? "100%" : "100vh",
          width: "100%",
          boxSizing: "border-box",
        }}
        className="py-2 d-flex flex-column justify-content-center align-items-center p-3"
      >
        <div
          style={{
            width: "100%",
            paddingTop: "0.5em",
            paddingBottom: is4kScreen
              ? "2rem"
              : isXxlScreen
              ? "1.5rem"
              : isXlScreen
              ? "1.5rem"
              : isLargeScreen
              ? "2rem"
              : isMediumScreen
              ? "1rem"
              : "",
          }}
        >
          <h1
            className="text-center"
            style={{
              fontWeight: "bold",
              color: "#4e585ae6",
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.6rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen
                ? "2.5rem"
                : isMediumScreen
                ? " 2.4rem"
                : isSmallScreen
                ? "2rem"
                : "",
            }}
          >
            Don't overpay for multi-family projects
          </h1>

          <h5
            className="text-center"
            style={{
              color: "#4e585ae6",
              fontSize: is4kScreen
                ? "2.9rem"
                : isXxlScreen
                ? "1.5rem"
                : isXlScreen
                ? "1.4rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1.4rem"
                : isMediumScreen
                ? "1.5rem"
                : isSmallScreen
                ? "1.1rem"
                : "",
            }}
          >
            we only charge for unique roof style and the site map is free.
          </h5>
        </div>

        <div style={{ paddingBottom: isSmallScreen ? "2rem" : "" }}>
          <Container
            style={{
              paddingTop: is4kScreen ? "1.5rem" : "",
              width: "100%",
              height: is4kScreen
                ? "70vh"
                : isXxlScreen
                ? "70vh"
                : isXlScreen
                ? "70vh"
                : isLargeScreen
                ? "70vh"
                : isMediumScreen
                ? ""
                : "auto",
            }}
          >
            <Row className="gap-4">
              <Col sm={6} md={6}>
                <div className="pt-2">
                  <p
                    className="text-center"
                    style={{
                      color: "#4e585ae6",
                      marginBottom: "0px",
                      marginLeft: isXlScreen ? "-12.5px" : "0px",
                      fontSize: is4kScreen
                        ? "3rem"
                        : isXxlScreen
                        ? "2rem"
                        : isXlScreen
                        ? "2.0rem"
                        : isIpadProPortrait
                        ? "2.6rem"
                        : isLargeScreen
                        ? "1.9rem"
                        : isMediumScreen
                        ? "1.9rem"
                        : "",
                    }}
                  >
                    <span
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "3.5rem"
                          : isXxlScreen
                          ? "2rem"
                          : isXlScreen
                          ? "2.3rem"
                          : isIpadProPortrait
                          ? "2.6rem"
                          : isLargeScreen
                          ? "1.9rem"
                          : "",
                      }}
                    >
                      6
                    </span>{" "}
                    roof styles:{" "}
                    <span
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "2rem"
                          : isXlScreen
                          ? "2.3rem"
                          : isIpadProPortrait
                          ? "2.6rem"
                          : isLargeScreen
                          ? "1.9rem"
                          : "",
                      }}
                    >
                      $180 USD
                    </span>
                  </p>

                  <div
                    style={{
                      backgroundColor: "#BAE5EC",
                      height: "100%",
                    }}
                  >
                    <p
                      className="text-center text-black mb-0 p-2"
                      style={{
                        fontSize: is4kScreen
                          ? "2.9rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.7rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.5rem"
                          : "",
                      }}
                    >
                      Rooftop Measurements
                    </p>
                    <div
                      style={{
                        width: "100%",
                        height: is4kScreen
                          ? "60vh"
                          : isXxlScreen
                          ? "55vh"
                          : isXlScreen
                          ? "50vh"
                          : isLargeScreen
                          ? "50vh"
                          : "30vh",
                      }}
                    >
                      <img
                        src="/images/Picture3.png"
                        alt="top"
                        style={{
                          width: "100%", // Fill the parent container
                          height: "100%", // Fill the parent container
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="pt-2">
                  <p
                    className="text-center"
                    style={{
                      color: "#4e585ae6",
                      marginBottom: "0px",
                      fontSize: is4kScreen
                        ? "3.5rem"
                        : isXxlScreen
                        ? "2rem"
                        : isXlScreen
                        ? "2.0rem"
                        : isIpadProPortrait
                        ? "2.6rem"
                        : isLargeScreen
                        ? "1.9rem"
                        : isMediumScreen
                        ? "1.9rem"
                        : "",
                    }}
                  >
                    <span
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "2rem"
                          : isXlScreen
                          ? "2.3rem"
                          : isIpadProPortrait
                          ? "2.6rem"
                          : isLargeScreen
                          ? "1.9rem"
                          : "",
                      }}
                    >
                      35
                    </span>{" "}
                    roofs:
                    <span
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "2rem"
                          : isXlScreen
                          ? "2.3rem"
                          : isIpadProPortrait
                          ? "2.6rem"
                          : isLargeScreen
                          ? "1.9rem"
                          : "",
                      }}
                    >
                      $2800 USD
                    </span>
                  </p>
                  <div style={{ backgroundColor: "#FFC145" }}>
                    <p
                      className="text-center text-black mb-0 p-2"
                      style={{
                        fontSize: is4kScreen
                          ? "2.9rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.7rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.5rem"
                          : "",
                      }}
                    >
                      The Other Guys
                    </p>
                    <div
                      style={{
                        width: "100%",
                        height: is4kScreen
                          ? "60vh"
                          : isXxlScreen
                          ? "55vh"
                          : isXlScreen
                          ? "50vh"
                          : isLargeScreen
                          ? "50vh"
                          : "30vh",
                      }}
                    >
                      <img
                        src="/images/Picture1.png"
                        alt="top"
                        style={{
                          width: "100%", // Fill the parent container
                          height: "100%", // Fill the parent container
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </div>
  );
}

{
  /* <section id="counts" className="counts py-4" style={{overflowY:"scroll"}}>
<div className="container py-4">
  <header className="section-header">
    <h3>Don't overpay for multi-family projects</h3>
    <p
      style={{
        fontSize: "26px",
        fontWeight: "normal",
        color: "#4E585A",
        marginBottom: "30px",
      }}
    >
      We only charge for unique roof style and the site map is free.
    </p>
  </header>
  <div className="row">
    <div className="col-lg-1 col-md-1 mt-4 mt-md-0"></div>
    <div className="col-lg-5 col-md-5 mt-4 mt-md-0">
      <div
        className="text-center"
        style={{
          fontSize: "25px",
          color: "#4E585A",
          position: "relative",
        }}
      >
        <strong>6</strong> roof styles: <strong>$180</strong>
      </div>
      <div className="box featured-L">
        <h3>Rooftop Measurements</h3>
        <img src="/images/Picture1.png" alt="top" />
      </div>
    </div>
    <div className="col-lg-5 col-md-5 mt-4 mt-md-0">
      <div
        className="text-center"
        style={{
          fontSize: "25px",
          color: "#4E585A",
          position: "relative",
        }}
      >
        <strong>35</strong> roofs: <strong>$2,800</strong>
      </div>
      <div className="box featured-R">
        <h3>The Other Guys</h3>
        <img src="/images/Picture3.png" alt="other"/>
      </div>
    </div>
    <div className="col-lg-1 col-md-1 mt-4 mt-md-0"></div>
  </div>
</div>
</section> */
}
